import logo from './logo.png';
import websearch from './websearch.svg';
import frame1 from './Frame 1.jpg';
import frame2 from './Frame 2.jpg';
import frame3 from './Frame 3.jpg';
import socialproof from './social-proof.svg';
import socialproofMob from './social-proofMob.svg';
import curve from './curve.png';
import hands from './hands.jpg';
import movecard1 from './movecard1.jpg';
import movecard2 from './movecard2.jpg';
import movecard3 from './movecard3.jpg';
import test1 from './testifier-image.jpg';
import globe from './globe.png';
import blog1 from './blog1.jpg';
import blog2 from './blog2.jpg';
import blog3 from './blog3.jpg';
import cta from './cta.png';
import cash from './cash.svg';
import mapsearch from './map-search.svg';
import fileinvoice from './file-invoice.svg';
import message from './message-2-plus.svg';
import LocalIcon from './loc-ship.svg';
import InternationalIcon from './int-ship.svg';
import book from './book.svg';
import box from './box.svg';
import addicon from './add-icon.svg';
import wing from './wing.png';
import paystack from './paystack.svg';
import shipconfirm from './shipconfirm.jpg';
import copy from './copy.svg';
import tracking from './tracking.jpg';
import chat from './chat.svg';
import track from './track.jpg';
import register from './register.jpg';
import apple from './apple.svg';
import facebook from './facebook.svg';
import google from './google.svg';
import incmail from './incmail.svg';
import useradd from './useradd.svg';
import shome from './shome.svg';
import packagex from './packagex.svg';
import invoice from './invoice.svg';
import savedloc from './savedloc.svg';
import help from './help.svg';
import settings from './settings.svg';
import logout from './logout.svg';
import profilepic from './profilepic.jpg';
import blogpic from './blogpic.jpg';
import paymentact from './paymentact.svg';
import about from './about.jpg';
import login from './login.jpg';
import quote from './quote.svg';
import analytics from './analytics.svg';
import users from './users.svg';

export {
    logo,
    websearch,
    frame1,
    frame2,
    frame3,
    socialproof,
    socialproofMob,
    curve,
    hands,
    movecard1,
    movecard2,
    movecard3,
    test1,
    globe,
    blog1,
    blog2,
    blog3,
    cta,
    mapsearch,
    message,
    fileinvoice,
    cash,
    LocalIcon,
    InternationalIcon,
    book,
    box,
    addicon,
    wing,
    paystack,
    shipconfirm,
    copy,
    tracking,
    chat,
    track,
    register,
    apple,
    facebook,
    google,
    incmail,
    useradd,
    savedloc,
    shome,
    packagex,
    invoice,
    help,
    settings,
    logout,
    profilepic,
    blogpic,
    paymentact,
    about,
    login,
    quote,
    analytics,
    users,
}

export const heroImages = [
    frame1, frame2, frame3, frame1, frame2
];